export default {
  path: '/shop-cart-order',
  meta: {
    title: '',
    keepAlive: true,
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/shop-cart-order`),
}



// WEBPACK FOOTER //
// ./src/views/shopCartOrder/router.js